/**
 * Lanificio — plaatst de garenbol-motieven (snippets/lan-garenbol-motief.liquid)
 * per pagina, van boven naar beneden:
 * - hooguit om de sectie een motief: volgt een sectie met motief direct op een
 *   andere sectie met motief, dan blijft het tweede weg;
 * - de kant wisselt: links en rechts om en om ten opzichte van de vorige
 *   sectie met motief (ook bij een vaste hoek wordt de kant zo nodig gespiegeld);
 * - bij "auto" altijd in een onderhoek (bovenaan staan meestal kop en
 *   inleiding, onderaan is ruimte); grootte (40–70% van de sectiehoogte) en hoe
 *   ver hij buiten beeld valt variëren, zodat het niet als een stempel herhaalt.
 * Een "sectie" is een .shopify-section, of een band daarin ([data-lan-band],
 * bijv. de lichte aanmeldbalk en het donkere deel van de footer).
 * Het script draait één keer, ook als het snippet vaker op de pagina staat.
 */
(function () {
  'use strict';
  if (window.__lanMotief) return;
  window.__lanMotief = true;

  var HOOGTES = [56, 68, 46, 62, 42, 70, 50, 64];
  var UIT = [0.38, 0.3, 0.44, 0.34, 0.4, 0.28];

  function units() {
    return Array.prototype.filter.call(document.querySelectorAll('.shopify-section, [data-lan-band]'), function (el) {
      if (el.classList.contains('shopify-section') && el.querySelector('[data-lan-band]')) return false; // de banden tellen
      if (el.closest('.header-section')) return false;
      return el.getBoundingClientRect().height > 1;
    });
  }

  function motiefVan(unit) {
    var m = unit.querySelector(':scope > [data-lan-motief]');
    return m || null;
  }

  function plaats() {
    var vorigeHadMotief = false;
    var vorigeKant = null;
    var n = 0;
    units().forEach(function (unit) {
      var m = motiefVan(unit);
      if (!m) {
        vorigeHadMotief = false;
        return;
      }
      if (vorigeHadMotief) {
        m.classList.remove('is-geplaatst');
        vorigeHadMotief = false;
        return;
      }
      var hoek = m.getAttribute('data-hoek') || 'auto';
      var kant;
      var hoogte;
      if (hoek === 'auto') {
        kant = vorigeKant === 'rechts' ? 'links' : 'rechts';
        hoogte = 'onder';
      } else {
        kant = hoek.indexOf('links') === 0 ? 'links' : 'rechts';
        hoogte = /boven$/.test(hoek) ? 'boven' : 'onder';
        if (kant === vorigeKant) kant = kant === 'links' ? 'rechts' : 'links';
      }
      ['linksboven', 'rechtsboven', 'linksonder', 'rechtsonder'].forEach(function (c) {
        m.classList.remove('lan-motief--' + c);
      });
      m.classList.add('lan-motief--' + kant + hoogte);
      m.style.setProperty('--lan-motief-h', HOOGTES[n % HOOGTES.length]);
      m.style.setProperty('--lan-motief-uit', UIT[n % UIT.length]);
      m.classList.add('is-geplaatst');
      vorigeKant = kant;
      vorigeHadMotief = true;
      n++;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plaats);
  else plaats();
  // Opnieuw na laden (beelden en lettertypes veranderen hoogtes niet de volgorde,
  // maar wel welke secties zichtbaar zijn) en in de editor na een sectie-herlaad.
  window.addEventListener('load', plaats);
  document.addEventListener('shopify:section:load', plaats);
  document.addEventListener('shopify:section:unload', function () { setTimeout(plaats, 0); });
})();
